import { initAxios } from '../utils/axiosHelper';

export interface IUploadDocument {
  file: File;
  document_id?: string;
  transaction_id: string;
  ai_enabled?: boolean;
  create_ticket?: boolean;
  similarity_threshold?: string;
}

export interface Headers {
  webhook_url?: string;
  secret: string;
  api_key: string;
  team_name: string;
}

export const PublicAPI = {
  // eslint-disable-next-line consistent-return
  upload_document: async (
    content: IUploadDocument,
    headers: Headers,
  ): Promise<any> => {
    const { api_key, team_name, secret, webhook_url } = headers;
    const formData = new FormData();
    formData.append('file', content.file);
    formData.append('transaction_id', content.transaction_id);
    formData.append('ai_enabled', content.ai_enabled?.toString() || 'false');
    formData.append(
      'create_ticket',
      content.create_ticket?.toString() || 'false',
    );
    formData.append(
      'similarity_threshold',
      content.similarity_threshold || '0%',
    );
    if (content.document_id) {
      formData.append('document_id', content.document_id);
    }

    const apiClient = await initAxios(process.env.REACT_APP_PUBLIC_API_URL);
    if (!apiClient) {
      return {
        success: false,
        data: 'Error initializing api client',
      };
    }

    return await apiClient
      .post('/api/v1/search/entities-bulk-document', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'webhook-url': webhook_url,
          secret: secret.trim(),
          'team-name': team_name.trim(),
          Authorization: `Bearer ${api_key.trim()}`,
        },
        timeout: 60000,
      })
      .then((resp) => {
        const message = resp.data?.data?.message;
        return {
          success: resp.status >= 200 && resp.status < 300,
          message: message,
          result: resp.data,
        };
      })
      .catch((err) => {
        let message = '';
        const main_message =
          err.response?.data?.error?.message ||
          err.response?.data?.message ||
          err.message ||
          'Unknown error';

        const nestedErrors = err.response?.data?.error?.errors
          ? Object.values(err.response.data.error.errors).flat().join(' ')
          : '';

        message = [main_message, nestedErrors].filter(Boolean).join(' - ');

        console.error(
          'API call failed in PublicAPI.upload_document:',
          err.response || err.message || err,
        );
        return {
          success: false,
          message: message,
          result: err.response?.data || {
            message: err.message,
            status: err.response?.status,
            errorDetail: err.toString(),
          },
        };
      });
  },
};
